import { PageHead } from '../components/ui';
import { SuccessCharter } from './charter/SuccessCharter';

/**
 * The COO Success Charter.
 *
 * The charter the standalone EOS app presents, brought across whole by
 * request — see `charter/SuccessCharter.tsx` for what came with it and the
 * three things that could not come literally.
 *
 * WHAT THIS REPLACED. The page used to be a record of the charter: a title, a
 * holder, a version and status, a review date, editable sections and a table
 * of success measures. That model is NOT deleted — `coo.Charter`,
 * `coo.CharterSection` and `coo.CharterMetric` still hold their rows and
 * `/api/charter` still serves and edits them — it just is not what this page
 * draws any more. Nothing else in the app reads those tables, so unlike the
 * dependency register there is no figure left pointing at them. See migration
 * 083.
 */
export function CharterPage() {
  return (
    <>
      <PageHead
        title="COO Success Charter"
        lede="What this seat is here to do, worked through end to end. Notes and deliverables save as you go; Save Charter stores them to the workspace and keeps a version you can come back to."
      />
      <SuccessCharter />
    </>
  );
}
